/* eslint-disable compat/compat */
class ProductUpsell extends window.BAO.CustomElement {
  connectedCallback () {
    super.connectedCallback()

    this.adding = false

    // Extract the variant from the query string if it exists
    const queryParams = new URLSearchParams(window.location.search)
    this.currentVariantId = queryParams.get('variant')

    this.updateHasProductUpsell()
  }

  setupListeners () {
    document.addEventListener('product-added', this.addProductToCart.bind(this))

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.VARIANT_CHANGE,
      e => {
        if (!e.detail.data.id) return
        this.currentVariantId = e.detail.data.id
        this.replaceMyself()
      }
    )
  }

  destroyListeners () {
    document.removeEventListener(
      'product-added',
      this.addProductToCart.bind(this)
    )

    window.BAO.eventBus.removeEventListener(
      window.BAO.EVENTS.VARIANT_CHANGE,
      e => {
        if (!e.detail.data.id) return
        this.currentVariantId = e.detail.data.id
        this.replaceMyself()
      }
    )
  }

  async replaceMyself () {
    if (this.dataset.disabled === 'true' || this.dataset.global === 'true')
      return

    // Get the current URL and split by '?', keeping everything before the query string
    const baseUrl = window.location.href.split('?')[0]

    const variant = this.currentVariantId

    // Construct the new URL, ensuring variant and other params are included
    let newUrl = `${baseUrl}`

    if (variant) {
      newUrl += `?variant=${variant}`
    }

    // Append any additional parameters from dataset.url
    if (this.dataset.url) {
      const additionalParams = new URLSearchParams(this.dataset.url)
      newUrl += variant ? `&${additionalParams}` : `?${additionalParams}`
    }

    try {
      const response = await fetch(newUrl)
      const text = await response.text()
      this.handleFetchResponse(text)
    } catch (e) {
      console.error('Fetch error:', e)
    }
  }

  handleFetchResponse (text) {
    // Create a temporary div to hold the fetched HTML
    const div = document.createElement('div')
    div.innerHTML = text

    // Find the product-auto-upsell section in the fetched HTML
    const fetchedUpsellElement = div.querySelector('.prd-DetailsUpsell')

    // Find the .prd-DetailsUpsell element in the current DOM
    const detailsUpsellElement = this.querySelector('.prd-DetailsUpsell')

    // Ensure we have both the fetched section and the target container
    if (fetchedUpsellElement && detailsUpsellElement) {
      // Update the innerHTML of .prd-DetailsUpsell with content from the fetched HTML
      detailsUpsellElement.innerHTML = fetchedUpsellElement.innerHTML

      // Update the upsell-id and upsell-product attributes on the current product-auto-upsell element
      const customElementGetter = div.querySelector('product-auto-upsell')
      const upsellId = customElementGetter.getAttribute('data-upsell-id')
      const upsellProduct = customElementGetter.getAttribute(
        'data-upsell-product'
      )

      if (upsellId) {
        this.setAttribute('data-upsell-id', upsellId)
      }

      if (upsellProduct) {
        this.setAttribute('data-upsell-product', upsellProduct)
        this.setHasProductUpsell(true)

        return
      }

      this.setHasProductUpsell(false)
    } else {
      console.warn(
        'No valid section found to update or no target container in the current DOM.'
      )
      detailsUpsellElement.innerHTML = ''
      this.setHasProductUpsell(false)
    }
  }

  async addProductToCart () {
    if (
      this.adding === true ||
      this.dataset.disabled === 'true' ||
      !this.dataset.upsellId
    )
      return

    const properties = {}
    if (this.dataset.upsellProperties) {
      properties[''] = this.dataset.upsellProperties
    }
    properties._upsellProduct = 'true'

    const cartItem = {
      id: this.dataset.upsellId,
      quantity: 1,
      properties,
    }

    try {
      this.adding = true
      const { cartItems } = await this.getCartInfo()
      const existingItem = cartItems.find(
        item => item.variant_id === this.dataset.upsellId
      )

      if (existingItem !== undefined) return

      await window.BAO.Cart.addItem(cartItem, null, {
        sections:
          window.BAO.utils.sectionRenderer?.pushCartSections?.map(
            s => s.section
          ) || [],
        sectionsUrl: window.location.pathname,
      })
      this.adding = false
    } catch (err) {
      console.error('Error adding item to cart:', err)
      this.adding = false
    }
  }

  async getCartInfo () {
    try {
      const response = await fetch('/cart.js')
      const cart = await response.json()

      const cartTotal = cart.total_price
      const cartItems = cart.items

      return { cartTotal, cartItems }
    } catch (error) {
      console.error('Error fetching cart total:', error)
      return { cartTotal: null, cartItems: null }
    }
  }

  updateHasProductUpsell () {
    const detailsUpsellElement = this.querySelector('.prd-DetailsUpsell')
    this.setHasProductUpsell(
      detailsUpsellElement && detailsUpsellElement.innerHTML.trim() !== ''
    )
  }

  setHasProductUpsell (hasUpsell) {
    const detailsFormElement = document.querySelector('.prd-Details_Form')
    if (detailsFormElement) {
      detailsFormElement.setAttribute(
        'data-has-product-upsell',
        hasUpsell ? 'true' : 'false'
      )
    }
  }
}

if (!customElements.get('product-auto-upsell')) {
  customElements.define('product-auto-upsell', ProductUpsell)
}
